import Vue from 'vue';

export const newAssignmentService = {
  async retrieveSelectedContractor(referenceNumber) {
    return Vue.axios
      .get('/assignments/user-quick-search', {
        params: {
          'contractors_view.reference_number': `${referenceNumber}`,
          object_type: 'contractor'
        }
      })
      .then(response => response.data);
  },

  async retrieveSelectedClientBillingMethod(clientId) {
    return Vue.axios
      .get('/assignments/billing-method-lookup', {
        params: {
          client_id: clientId
        }
      })
      .then(response => response.data);
  }
};
